import { render, staticRenderFns } from "./NotificationMnemonicBackup.vue?vue&type=template&id=29a73f54&scoped=true"
import script from "./NotificationMnemonicBackup.vue?vue&type=script&lang=js"
export * from "./NotificationMnemonicBackup.vue?vue&type=script&lang=js"
import style0 from "./NotificationMnemonicBackup.vue?vue&type=style&index=0&id=29a73f54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a73f54",
  null
  
)

export default component.exports